import type { Booking } from '@/features/appointments/types/appointment.types';

/**
 * Export booking details to CSV file
 */
export function exportBookingToCSV(booking: Booking) {
    // Parse booking date
    const bookingDate = new Date(booking.start_utc);

    // Format times for display (local time)
    const formatDateTime = (isoString: string) => {
        const date = new Date(isoString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    // Create CSV content
    const headers = ['Name', 'Email', 'Meeting Title', 'Start Time', 'End Time', 'Status'];
    const csvRows = [headers.join(',')];

    // Add attendee data
    booking.attendees.forEach(attendee => {
        const row = [
            `"${attendee.name}"`,
            `"${attendee.email}"`,
            `"${booking.title}"`,
            `"${formatDateTime(booking.start_utc)}"`,
            `"${formatDateTime(booking.end_utc)}"`,
            `"${attendee.status || ''}"`,
        ];
        csvRows.push(row.join(','));
    });

    const csvContent = csvRows.join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);

    const year = bookingDate.getFullYear();
    const month = String(bookingDate.getMonth() + 1).padStart(2, '0');
    const day = String(bookingDate.getDate()).padStart(2, '0');
    const hours = String(bookingDate.getHours()).padStart(2, '0');
    const minutes = String(bookingDate.getMinutes()).padStart(2, '0');
    const seconds = String(bookingDate.getSeconds()).padStart(2, '0');
    const timestamp = `${year}-${month}-${day}T${hours}-${minutes}-${seconds}`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.replace('/', '_');
    const filename = `Meeting Details - ${timestamp}+${timezone}.csv`;

    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
